import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Local (per-agent, client-side) preferences surfaced in Settings. These are
 *  UX conveniences persisted to localStorage — they are NOT server settings.
 *  (Availability and concurrency cap ARE server-backed and live elsewhere.) */
export interface NotifPrefs {
  desktop: boolean;
  sound: boolean;
  new: boolean;
  consult: boolean;
  sla: boolean;
}

interface PrefsState {
  notif: NotifPrefs;
  setNotif: (key: keyof NotifPrefs, value: boolean) => void;
  autoAssign: boolean;
  setAutoAssign: (value: boolean) => void;
  quickReplies: string[];
  addQuickReply: (text: string) => void;
  updateQuickReply: (index: number, text: string) => void;
  removeQuickReply: (index: number) => void;
}

const DEFAULT_QUICK_REPLIES = [
  'Thanks for reaching out! Let me look into that for you.',
  "I've escalated this to our team — you'll hear back shortly.",
  'Is there anything else I can help you with today?',
];

export const usePrefsStore = create<PrefsState>()(
  persist(
    (set) => ({
      notif: { desktop: true, sound: true, new: true, consult: true, sla: true },
      setNotif: (key, value) => set((s) => ({ notif: { ...s.notif, [key]: value } })),
      autoAssign: true,
      setAutoAssign: (value) => set({ autoAssign: value }),
      quickReplies: DEFAULT_QUICK_REPLIES,
      addQuickReply: (text) => set((s) => ({ quickReplies: [...s.quickReplies, text] })),
      updateQuickReply: (index, text) =>
        set((s) => ({ quickReplies: s.quickReplies.map((q, i) => (i === index ? text : q)) })),
      removeQuickReply: (index) =>
        set((s) => ({ quickReplies: s.quickReplies.filter((_, i) => i !== index) })),
    }),
    { name: 'css-agent-prefs' },
  ),
);
